/*
 * @Author: yubin97 yubin97@jd.com
 * @Date: 2024-10-22 17:49:17
 * @LastEditors: yubin97 yubin97@jd.com
 * @LastEditTime: 2025-03-11 16:58:56
 * @FilePath: /micro-main/src/components/iframe-view/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import "./index.less";

import { useSelector } from "react-redux";
import { TStoreData } from "../../interface";
import { appendUrlParams, setCookie } from "@/util/tools";
import { getHost } from "@/util/host";
import { getLoginType } from "@/util/env";
import { MAP_TENANT_FIRST_CODE, TENANT_ENV } from "@/constants/tenants";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Spin } from "antd";

export function IframeView() {
    const location = useLocation();
    const storeData = useSelector((data: TStoreData) => {
        return {
            subMenuList: data.subMenuList,
            firstTenant: data?.firstTenant,
        };
    });
    const { subMenuList, firstTenant } = storeData;
    const [loading, setLoading] = useState(true)
    const [src, setSrc] = useState<string>('')

    useEffect(() => {
        if (firstTenant.tenantCode)
            getSrc()
    }, [location.pathname, location.hash, firstTenant.tenantCode])

    const getSrc = () => {
        setLoading(true)
        let src = location.pathname?.split("/iframe-view/")?.[1] || "";

        if (!location.pathname.startsWith("/iframe-view/")) {
            const path = location.pathname;
            src =
                path?.indexOf("http") !== -1
                    ? decodeURIComponent(path.replace(/\//g, ""))
                    : `${path}`;
        }

        src = decodeURIComponent(src);
        if (process.env.REACT_APP_ENV === "gray") {
            src = src.replace("new-crm", "gray-new-crm");
            src = src.replace("mark.jd.com", "gray-mark.jd.com");
        }
        src = appendUrlParams(src, {
            devHost: getHost().xiaobBaseUrl.replace("//", ""),
            loginType: getLoginType().toString(),
        });

        if (
            firstTenant.tenantCode === MAP_TENANT_FIRST_CODE[TENANT_ENV.JDDJ] &&
            src.includes("jddj.com")
        ) {
            setCookie().then(() => {
                setSrc(src)
            }).catch(err => {
                console.log('setCookie err', err);

            }).finally(() => {
                setLoading(false)
            })
        } else {
            setSrc(src)
            setLoading(false)
        }
    }
    // TODO: 140px 得判断
    return <Spin spinning={loading} className="iframe-view">
        {src ? (
            <div
                className="lr-content-x-frame-box"
            >
                <iframe
                    allow="fullscreen;autoplay;microphone;camera"
                    className={`lr-x-frame`}
                    title="内嵌页面"
                    key={src}
                    src={src}
                />
            </div>
        ) : (
            <div className="lr-content-x-frame-none">{loading ? '' : '您访问的页面不存在'}</div>
        )}
    </Spin>



}

export default IframeView;
